module.exports = __webpack_public_path__ + "img/sony-xperia-xa1-ultra.f14a7ee1.jpg";